export const isEqualArrays = (arr1: any[], arr2: any[], fieldCondition: string) => {
  if (arr1.length !== arr2.length) {
    return false;
  }

  const a1 = [...arr1];
  const a2 = [...arr2];

  let isEqual: boolean;

  if (fieldCondition) {
    isEqual = a1
      .sort()
      .every((value, index) => value[fieldCondition] === a2.sort()[index][fieldCondition]);
  } else {
    isEqual = a1.sort().every((value, index) => value === a2.sort()[index]);
  }

  return isEqual;
};
